import React from 'react';

import { Children } from '../types';
import style from './index.module.css';

type Props = {
    book?: boolean;
    medium?: boolean;
    bold?: boolean;
    small?: boolean;
    extraSmall?: boolean;
} & Children;

export const Paragraph = ({ book, bold, small, extraSmall, children }: Props) => (
    <span
        className={`${style.paragraph} ${book ? style.book : ''} ${bold ? style.bold : ''} ${small ? style.small : ''}
    ${extraSmall ? style.extraSmall : ''}`}
    >
        {children}
    </span>
);
